import React from 'react';
import { checkPassword, sendLoginPayload } from 'account-portal-library/lib/emailSignIn';
import { parseCookies, setCookies, validateSessionToken, isValidGoToURL } from "account-portal-library/lib/helperFunctions";
import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';

import TOPasswordFormView from '../Views/TO/Login/PasswordFormView';
import { getGotoUrlFromCookies } from '../../gotoUrl.js';

let appVars = AppVars.getInstance()
let logger = Logger.getInstance();

const ACCOUNT_LOCKED_URL = "/accountlocked"
const INPUT_TYPES = {
    "PHONE": "^(?!0)[0-9]{10}$",
    "EMAIL": "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)"
}

class PasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            displayUsername: this.props.username,
            password: "",
            payload: null,
            loading: false,
            showPassword: false,
            isPasswordValid: null,
            isLoginValid: null,
            onFocus: false,
            floatLabel: true,
        };
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.removeFocus = this.removeFocus.bind(this);
        this.hideModalLocked = this.hideModalLocked.bind(this);
        this.hideModalInvalid = this.hideModalInvalid.bind(this);
        this.showHidePassword = this.showHidePassword.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.saveURI = this.saveURI.bind(this);
    }

    componentDidMount() {
        if (this.props.signInType === "PHONE" || this.props.signInType === "OTP") {
            var username = this.props.username
            var displayPhone = "(" + username.substring(0, 3) + ") " + username.substring(3, 6) + "-" + username.substring(6, 10)
            this.setState({ displayUsername: displayPhone })
        }
    }

    async handleFormSubmit(event) {
        //Prevent default submit button behavior
        event.preventDefault();
        this.setState({ isPasswordValid: null, isLoginValid: null, loading: true })
        //Check that form isn't blank
        const valid = this.validateInput();
        // this.setState({ loading: false })

        if (valid) {
            this.setState({ loading: true })
            let passwordPayload = this.props.payload;
            if (this.state.payload != null) {
                passwordPayload = this.state.payload
            }
            try {
                const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
                // const url = appVars.getAMBaseURL() + '/json' + appVars.getRealm() + '/authenticate';
                const params = {
                    'authIndexType': 'service',
                    'authIndexValue': appVars.getSignInTree()
                };
                const headers = {
                    'Accept-API-Version': 'resource=1.1',
                    'Content-Type': 'application/json',
                };

                if (passwordPayload.callbacks.length === 1) {
                    passwordPayload.callbacks[0].input[0].value = this.state.password;
                } else {
                    console.log("Invalid password payload structure");
                    throw passwordPayload;
                }

                const journeyResponse = await sendLoginPayload(passwordPayload, url, headers, params);
                console.log("Journey Response(Password Submit) -> ", journeyResponse);

                if (journeyResponse.status !== 200) {
                    throw journeyResponse.response;
                }
                this.handleSuccess(journeyResponse.response);

            } catch (errorResponse) {
                console.log("Error -> ", errorResponse);
                this.handleFailure(errorResponse);
            }
        }
    }

    checkUsernameType(username) {
        var TYPE = null;
        for (const key in INPUT_TYPES) {
            if (username.match(INPUT_TYPES[key]) && appVars.getIncludeSignIn(key)) {
                TYPE = key;
            }
        }
        logger.log("local", "Sign in type: " + TYPE);
        return TYPE;
    }

    validateInput() {
        var isPasswordValid = this.validatePassword(this.state.password);
        this.setState({ isPasswordValid: isPasswordValid });
        return (isPasswordValid)
    }

    handleLoginResponse(loginResponse) {
        if (this.validateForm(loginResponse.status)) {
            this.handleSuccess(loginResponse);
        } else {
            this.handleFailure(loginResponse);
        }
    }

    //Checks that there is a session cookie on the browser
    async checkToken(journeyResponse) {
        try {
            const tokenId = journeyResponse.tokenId
            if (tokenId != null) {
                const validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                console.log("validateResponse (checkToken) -> ", validateResponse)
                return validateResponse.response.valid;
            } else {
                return false
            }
        }
        catch {
            return false
        }

    }

    handleFailure(journeyResponse) {
        const failureUrl = journeyResponse.failureUrl
        // Invalid credentials - after 5 unsuccessful password attempts
        if (failureUrl === ACCOUNT_LOCKED_URL) {
            this.setState({ loading: false })
            this.setState({ isAccountLocked: true })
        }
        else {
            //this.setState({loading: false})
            window.location.replace(appVars.getUnknownErrorURL(this.props.style));
        }
    }

    async handleSuccess(journeyResponse) {
        if (journeyResponse.successUrl === "/console") {
            if (this.validateForm(journeyResponse)) {
                if (journeyResponse.callbacks != null) {
                    this.props.savePayload(journeyResponse)
                    this.props.saveStep("SELECT")
                } else {
                    this.setState({ loading: true })
                    var tokenValid = await this.checkToken(journeyResponse);
                    this.setState({ loading: false })
                    console.log('Token Valid -> ', tokenValid)
                    if (tokenValid) {
                        const gotoUrl = getGotoUrlFromCookies(['T']);
                        window.location.replace(gotoUrl);
                    } else {
                        window.location.replace(appVars.getUnknownErrorURL(this.props.style));
                    }
                }
            } else {
                this.handleFailure(journeyResponse)
            }
        } else if(journeyResponse.callbacks[0].type === "ChoiceCallback"){
            this.setState({ payload: journeyResponse, loading: false, isAccountLocked: true });
        } else if (journeyResponse.callbacks[0].type === "PasswordCallback") {
            this.setState({ payload: journeyResponse, loading: false, isLoginValid: false });
        } else {
            window.location.replace(appVars.getUnknownErrorURL(this.props.style));
        }
    }

    validatePassword(password) {
        if (password == undefined || password == null || password.length === 0) {
            return false;
        }
        return true;
    }

    validateForm(status) {
        if (status > 299) {
            return false;
        }
        else {
            return true;
        }
    }

    saveURI() {
        logger.log('stage', this.props.style)
        if (this.props.style === "DG") {
            setCookies("login_uri", window.location.href, "/", appVars.getDomain())
        }
        window.location.replace(appVars.getForgotPasswordURL(this.props.style))
    }

    handlePasswordChange(event) {
        const password = event.target.value;
        this.setState({ password, isPasswordValid: this.validatePassword(event.target.value) })
    }

    setFocus(event) {
        this.setState({ onFocus: true })
        this.setState({ floatLabel: false })
    }

    removeFocus() {
        this.setState({ onFocus: false })
    }

    onBlur() {
        if (this.state.password === "") {
            this.setState({ floatLabel: true })
        } else {
            this.setState({ floatLabel: false })
        }
        this.removeFocus()
        this.setState({ isPasswordValid: this.validatePassword(this.state.password) })
    }

    hideModalLocked() {
        this.setState({ isAccountLocked: null })
    }

    hideModalInvalid() {
        this.setState({ isLoginValid: null })
    }

    showHidePassword() {
        this.setState({ showPassword: !this.state.showPassword })
    }

    render() {
        return (
            <TOPasswordFormView
                style={this.props.style}
                username={this.props.username}
                displayUsername={this.state.displayUsername}
                password={this.state.password}
                loading={this.state.loading}
                showPassword={this.state.showPassword}
                isPasswordValid={this.state.isPasswordValid}
                isFormValid={this.state.isFormValid}
                isLoginValid={this.state.isLoginValid}
                isAccountLocked={this.state.isAccountLocked}
                handleFormSubmit={this.handleFormSubmit}
                handlePasswordChange={this.handlePasswordChange}
                onFocus={this.state.onFocus}
                setFocus={this.setFocus}
                removeFocus={this.removeFocus}
                signInType={this.props.signInType}
                hideModalInvalid={this.hideModalInvalid}
                hideModalLocked={this.hideModalLocked}
                showHidePassword={this.showHidePassword}
                onBlur={this.onBlur}
                floatLabel={this.state.floatLabel}
                saveURI={this.saveURI}
            />
        );
    }
}

export default PasswordForm;